module.exports = __webpack_public_path__ + "img/proj2-predprin.d826e7fa.png";